import React, { useEffect } from 'react'
import Chart from "chart.js";
import 'chartjs-plugin-datalabels';
import "./BarAndLineChart.css";

export default function BarAndLineChart(props) {
  const chartRef = React.createRef();

  useEffect(() => {

    const mixedChartRef = chartRef.current.getContext("2d");
    const cDataSet = [
      {
        type: 'line',
        axis: 'y',
        pointRadius: 2,
        data: props.qoqReport.fixedRevenueAmount,
        borderColor: props.fixedColor,
        pointBackgroundColor: props.pointColor,
        pointBorderColor: props.pointColor,
        yAxisID: 'y1',
        fill: false,
        order: 1,
        lineTension: 0
      },
      {
        type: 'line',
        axis: 'y',
        pointBackgroundColor: props.pointColor,
        pointBorderColor: props.pointColor,
        pointRadius: 2,
        data: props.qoqReport.variableRevenueAmount,
        borderColor: props.variableColor,
        fill: false,
        yAxisID: 'y1',
        order: 1,
        lineTension: 0
      },
      {
        id: "fixedContractPercent",
        type: 'bar',
        data: props.qoqReport.fixedContractPercent,
        borderColor: props.borderColor,
        backgroundColor: props.fixedColor,
        stack: 'Stack 0',
        barPercentage: 0.5,
        yAxisID: 'y',
        order: 2
      },
      {
        type: 'bar',
        stack: 'Stack 0',
        id: "variableContractPercent",
        borderColor: props.borderColor,
        backgroundColor: props.variableColor,
        barPercentage: 0.5,
        yAxisID: 'y',
        data: props.qoqReport.variableContractPercent,
        order: 2,
        display: false
      },
    ];

    const cData = {
      datasets: cDataSet,
      labels: props.qoqReport.quarters,
    }

    new Chart(mixedChartRef, {
      type: 'bar',
      data: cData,
      options: {
        animation: {
          duration: 0,
        },
        legend: {
          display: false,
          position: 'bottom',
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'point',
          callbacks: {
            label: function(tooltipItem, data) {
              return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] !==null && data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] !==undefined ? 
                      tooltipItem.datasetIndex > 1 ? data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                      : data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('nl-BE') 
                      : data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] ;
            },
          }
        },
        hover: () => {},
        plugins: {
          datalabels: {
            color: "#FFF",
            font: {
              weight: 'bold',
              size: 10,
            },
            formatter: function(value, context) {
                if (context && context.dataset && (context.dataset.id === "variableContractPercent" ||
                context.dataset.id === "fixedContractPercent"))
                {
                    return value ? value.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : value;
                }
                return "";
            }
          },
        },
        scales: {
          xAxes: [{
            ticks: {
              fontSize: 12,
              padding: 0,
              fontColor: '#25336C'
            }
          }],
          yAxes: [{
            id: "y",
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              fontSize: 12,
              padding: 0,
              fontColor: '#25336C',
              steps: 10,
              stepValue: 5,
              callback: function(value, index, values) {
                return value ? value.toLocaleString('nl-BE', {minimumFractionDigits: 0, maximumFractionDigits: 0}) : value;
              }
            },
            scaleLabel: {
              display: true,
              labelString: props.usePerQtrTitle,
              fontStyle: 'bold',
              fontSize: 12,
              fontColor: "#25336C"
            }
          },
          {
            type: 'linear',
            position: 'right',
            id: "y1",
            ticks: {
              fontSize: 12,
              padding: 0,
              beginAtZero: true,
              fontColor: '#25336C',
              callback: function(value, index, values) {
                return value ? value.toLocaleString('nl-BE') + ' €' : value;
              }
            },
            scaleLabel: {
              display: true,
              fontStyle: 'bold',
              fontSize: 12,
              labelString: props.revenuePerQtrTitle,
              fontColor: "#25336C"
            }
          }],
        }
      }
    });
  });
  return (
    <div className="chartjs-render-monitor mixchart-container">
      <canvas id="mixChart" ref={chartRef} />
    </div>
  )
}